import { PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { AreaOfUse, AreaOfUseEditParams, AreaOfUseList, HttpErrorModel } from '../../../../core/model';
import { PyStateUtils } from '../../../../core/state/utils';
import {
  AREAS_OF_USE_PUBLISH_ADMIN,
  AREA_OF_USE_CATEGORY_ADMIN,
  AREA_OF_USE_CATEGORY_DETAILS,
  AREA_OF_USE_EXCLUDE_ARTICLES,
  AREA_OF_USE_LIST_ADMIN,
  AREA_OF_USE_PRODUCTS,
  AREA_OF_USE_PRODUCTS_ADD,
  AREA_OF_USE_PRODUCTS_REMOVE,
  AREA_OF_USE_PRODUCTS_REPLACE,
  CREATE_AREA_OF_USE_CATEGORY_PROCESS,
} from '../area-of-use-admin-state';

export enum AreaOfUseAdminActionTypes {
  LoadAreasOfUseForProduct = '[AreaOfUseAdmin] Load Areas of use for product',
  LoadAreasOfUseForProductSuccess = '[AreaOfUseAdmin] Load Areas of use for product success',
  LoadAreasOfUseForProductFail = '[AreaOfUseAdmin] Load Areas of use for product fail',
  LoadAreasOfUseForProductReset = '[AreaOfUseAdmin] Reset load Areas of use for product',
  RemoveProductsFromAreaOfUseReset = '[AreaOfUseAdmin] Reset remove product from Areas of use',
  AddProductToAreaOfUseReset = '[AreaOfUseAdmin] Reset add product to Areas of use',
  AddProductToAreaOfUse = '[AreaOfUseAdmin] Add product to area of use',
  AddProductToAreaOfUseSuccess = '[AreaOfUseAdmin] Add product to area of use success',
  AddProductToAreaOfUseFail = '[AreaOfUseAdmin] Add product to area of use fail',
  ExcludeArticlesFromAreaOfUse = '[AreaOfUseAdmin] Exclude articles from area of use',
  ExcludeArticlesFromAreaOfUseSuccess = '[AreaOfUseAdmin] Exclude articles from area of use success',
  ExcludeArticlesFromAreaOfUseFail = '[AreaOfUseAdmin] Exclude articles from area of use fail',
  RemoveProductsFromAreaOfUse = '[AreaOfUseAdmin] Remove products from area of use',
  RemoveProductsFromAreaOfUseSuccess = '[AreaOfUseAdmin] Remove product from area of use success',
  RemoveProductsFromAreaOfUseFail = '[AreaOfUseAdmin] Remove product from area of use fail',
  LoadAreaOfUseListAdmin = '[AreaOfUseAdmin] Load Area of Use list admin',
  LoadAreaOfUseListAdminSuccess = '[AreaOfUseAdmin] Load Area of Use list admin success',
  LoadAreaOfUseListAdminFail = '[AreaOfUseAdmin] Load Area of Use list admin fail',
  LoadAreaOfUseListAdminReset = '[AreaOfUseAdmin] Load Area of Use list admin reset',
  LoadAreaOfUseCategoryAdminSuccess = '[AreaOfUseAdmin] Load Area of Use category admin success',
  CreateAreaOfUseCategoryAdmin = '[AreaOfUseAdmin] Create Area of Use category admin',
  CreateAreaOfUseCategoryAdminSuccess = '[AreaOfUseAdmin] Create Area of Use category admin success',
  CreateAreaOfUseCategoryAdminFail = '[AreaOfUseAdmin] Create Area of Use category admin fail',
  DeleteAreaOfUseCategoryAdmin = '[AreaOfUseAdmin] Delete Area of Use category admin',
  DeleteAreaOfUseCategoryAdminSuccess = '[AreaOfUseAdmin] Delete Area of Use category admin success',
  DeleteAreaOfUseCategoryAdminFail = '[AreaOfUseAdmin] Delete Area of Use category admin fail',
  EditAreaOfUseCategoryAdmin = '[AreaOfUseAdmin] Edit Area of Use category admin',
  EditAreaOfUseCategoryAdminFail = '[AreaOfUseAdmin] Edit Area of Use category admin fail',
  EditAreaOfUseCategoryAdminSuccess = '[AreaOfUseAdmin] Edit Area of Use category admin success',
  PublishAreasOfUseAdmin = '[AreaOfUseAdmin] Publish Areas of Use admin',
  PublishAreasOfUseAdminFail = '[AreaOfUseAdmin] Publish Areas of Use admin fail',
  PublishAreasOfUseAdminSuccess = '[AreaOfUseAdmin] Publish Areas of Use admin success',
  LoadAreaOfUseCategoryDetails = '[AreaOfUseAdmin] Load Area of Use category details',
  LoadAreaOfUseCategoryDetailsSuccess = '[AreaOfUseAdmin] Load Area of Use category details success',
  LoadAreaOfUseCategoryDetailsFail = '[AreaOfUseAdmin] Load Area of Use category details fail',
  LoadAreaOfUseCategoryDetailsReset = '[AreaOfUseAdmin] Load Area of Use category details reset',
  ReplaceAreaOfUseAdminProduct = '[AreaOfUseAdmin] Replace Area of use product',
  ReplaceAreaOfUseAdminProductFail = '[AreaOfUseAdmin] Replace Area of use product fail',
  ReplaceAreaOfUseAdminProductSuccess = '[AreaOfUseAdmin] Replace Area of use product success',
}

interface CreateAreaOfUseCategoryAdminPayload {
  userId: string;
  areaOfUseName: string;
  parentAreaOfUseCode?: string;
}

interface CreateAreaOfUseCategoryAdminSuccessPayload extends CreateAreaOfUseCategoryAdminPayload {
  areaOfUseCategory: AreaOfUse;
}

interface CreateAreaOfUseCategoryAdminFailPayload extends CreateAreaOfUseCategoryAdminPayload {
  error?: HttpErrorModel;
}

interface DeleteAreaOfUseCategoryAdminPayload {
  userId: string;
  code: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DeleteAreaOfUseCategoryAdminSuccessPayload extends DeleteAreaOfUseCategoryAdminPayload {}

interface DeleteAreaOfUseCategoryAdminFailPayload extends DeleteAreaOfUseCategoryAdminPayload {
  error?: HttpErrorModel;
}

interface EditAreaOfUseCategoryAdminPayload {
  userId: string;
  code: string;
  params: AreaOfUseEditParams;
  requiresListReload?: boolean;
}

interface EditAreaOfUseCategoryAdminSuccessPayload {
  areaOfUse: AreaOfUse;
  requiresListReload?: boolean;
}

interface LoadAreasOfUseForProductPayload {
  userId: string;
  productCode: string;
}

interface LoadAreasOfUseCategoryDetailsPayload {
  userId: string;
  code: string;
}

interface AddProductToAreaOfUsePayload {
  userId: string;
  productCode: string;
  categoryCode: string;
}

interface ExcludeArticlesFromAreaOfUsePayload {
  userId: string;
  categoryCode: string;
  excludedArticleCodes: string[];
  changedArticleCodes: string[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RemoveProductsFromAreaOfUsePayload {
  userId: string;
  productCodes: string[];
  categoryCode: string;
}

interface EditAreaOfUseCategoryAdminFailPayload extends EditAreaOfUseCategoryAdminPayload {
  error?: HttpErrorModel;
}

export class LoadAreasOfUseForProduct extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreasOfUseForProduct;

  constructor(public payload: LoadAreasOfUseForProductPayload) {
    super(AREA_OF_USE_PRODUCTS);
  }
}

export class LoadAreasOfUseForProductSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreasOfUseForProductSuccess;

  constructor(public payload: AreaOfUseList) {
    super(AREA_OF_USE_PRODUCTS);
  }
}

export class LoadAreasOfUseForProductFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreasOfUseForProductFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_PRODUCTS, payload);
  }
}

export class LoadAreasOfUseForProductReset extends StateUtils.LoaderResetAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreasOfUseForProductReset;

  constructor() {
    super(AREA_OF_USE_PRODUCTS);
  }
}

export class ExcludeArticlesFromAreaOfUse extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.ExcludeArticlesFromAreaOfUse;

  constructor(public payload: ExcludeArticlesFromAreaOfUsePayload) {
    super(AREA_OF_USE_EXCLUDE_ARTICLES);
  }
}

export class ExcludeArticlesFromAreaOfUseSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.ExcludeArticlesFromAreaOfUseSuccess;

  constructor(public payload: ExcludeArticlesFromAreaOfUsePayload) {
    super(AREA_OF_USE_EXCLUDE_ARTICLES);
  }
}

export class ExcludeArticlesFromAreaOfUseFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.ExcludeArticlesFromAreaOfUseFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_EXCLUDE_ARTICLES, payload);
  }
}

export class AddProductToAreaOfUse extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.AddProductToAreaOfUse;

  constructor(public payload: AddProductToAreaOfUsePayload) {
    super(AREA_OF_USE_PRODUCTS_ADD);
  }
}

export class AddProductToAreaOfUseSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.AddProductToAreaOfUseSuccess;

  constructor(public payload: AddProductToAreaOfUsePayload) {
    super(AREA_OF_USE_PRODUCTS_ADD);
  }
}

export class AddProductToAreaOfUseFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.AddProductToAreaOfUseFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_PRODUCTS_ADD, payload);
  }
}

export class AddProductToAreaOfUseReset extends StateUtils.LoaderResetAction {
  readonly type = AreaOfUseAdminActionTypes.AddProductToAreaOfUseReset;

  constructor() {
    super(AREA_OF_USE_PRODUCTS_ADD);
  }
}

export class RemoveProductsFromAreaOfUse extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.RemoveProductsFromAreaOfUse;

  constructor(public payload: RemoveProductsFromAreaOfUsePayload) {
    super(AREA_OF_USE_PRODUCTS_REMOVE);
  }
}

export class RemoveProductsFromAreaOfUseSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.RemoveProductsFromAreaOfUseSuccess;

  constructor(public payload: RemoveProductsFromAreaOfUsePayload) {
    super(AREA_OF_USE_PRODUCTS_REMOVE);
  }
}

export class RemoveProductsFromAreaOfUseFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.RemoveProductsFromAreaOfUseFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_PRODUCTS_REMOVE, payload);
  }
}

export class RemoveProductsFromAreaOfUseReset extends StateUtils.LoaderResetAction {
  readonly type = AreaOfUseAdminActionTypes.RemoveProductsFromAreaOfUseReset;

  constructor() {
    super(AREA_OF_USE_PRODUCTS_REMOVE);
  }
}

export class LoadAreaOfUseCategoryDetails extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryDetails;

  constructor(public payload: LoadAreasOfUseCategoryDetailsPayload) {
    super(AREA_OF_USE_CATEGORY_DETAILS);
  }
}

export class LoadAreaOfUseCategoryDetailsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryDetailsSuccess;

  constructor(public payload: AreaOfUse) {
    super(AREA_OF_USE_CATEGORY_DETAILS);
  }
}

export class LoadAreaOfUseCategoryDetailsFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryDetailsFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_CATEGORY_DETAILS, payload);
  }
}

export class LoadAreaOfUseCategoryDetailsReset extends StateUtils.LoaderResetAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryDetailsReset;

  constructor() {
    super(AREA_OF_USE_CATEGORY_DETAILS);
  }
}

export class LoadAreaOfUseListAdmin extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseListAdmin;

  constructor(public payload: string) {
    super(AREA_OF_USE_LIST_ADMIN);
  }
}

export class LoadAreaOfUseListAdminSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseListAdminSuccess;

  constructor(public payload: AreaOfUseList) {
    super(AREA_OF_USE_LIST_ADMIN);
  }
}

export class LoadAreaOfUseListAdminFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseListAdminFail;

  constructor(public payload?: any) {
    super(AREA_OF_USE_LIST_ADMIN, payload);
  }
}

export class LoadAreaOfUseListAdminReset extends StateUtils.LoaderResetAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseListAdminReset;

  constructor() {
    super(AREA_OF_USE_LIST_ADMIN);
  }
}

export class LoadAreaOfUseCategoryAdminSuccess extends StateUtils.EntitySuccessAction {
  readonly type = AreaOfUseAdminActionTypes.LoadAreaOfUseCategoryAdminSuccess;
  constructor(public payload: AreaOfUse | AreaOfUse[]) {
    super(AREA_OF_USE_CATEGORY_ADMIN, Array.isArray(payload) ? payload.map((areaOfUse) => areaOfUse?.code) : payload?.code);
  }
}
export class CreateAreaOfUseCategoryAdmin extends StateUtils.EntityLoadAction {
  readonly type = AreaOfUseAdminActionTypes.CreateAreaOfUseCategoryAdmin;

  constructor(public payload: CreateAreaOfUseCategoryAdminPayload) {
    super(PROCESS_FEATURE, CREATE_AREA_OF_USE_CATEGORY_PROCESS);
  }
}

export class CreateAreaOfUseCategoryAdminSuccess extends StateUtils.EntitySuccessAction {
  readonly type = AreaOfUseAdminActionTypes.CreateAreaOfUseCategoryAdminSuccess;

  constructor(public payload: CreateAreaOfUseCategoryAdminSuccessPayload) {
    super(PROCESS_FEATURE, CREATE_AREA_OF_USE_CATEGORY_PROCESS);
  }
}
export class CreateAreaOfUseCategoryAdminFail extends PyStateUtils.EntityFailAction {
  readonly type = AreaOfUseAdminActionTypes.CreateAreaOfUseCategoryAdminFail;

  constructor(public payload: CreateAreaOfUseCategoryAdminFailPayload) {
    super(PROCESS_FEATURE, CREATE_AREA_OF_USE_CATEGORY_PROCESS, payload.error);
  }
}

export class DeleteAreaOfUseCategoryAdmin extends StateUtils.EntityLoadAction {
  readonly type = AreaOfUseAdminActionTypes.DeleteAreaOfUseCategoryAdmin;

  constructor(public payload: DeleteAreaOfUseCategoryAdminPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.code);
  }
}

export class DeleteAreaOfUseCategoryAdminSuccess extends StateUtils.EntitySuccessAction {
  readonly type = AreaOfUseAdminActionTypes.DeleteAreaOfUseCategoryAdminSuccess;

  constructor(public payload: DeleteAreaOfUseCategoryAdminSuccessPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.code);
  }
}

export class DeleteAreaOfUseCategoryAdminFail extends PyStateUtils.EntityFailAction {
  readonly type = AreaOfUseAdminActionTypes.DeleteAreaOfUseCategoryAdminFail;

  constructor(public payload: DeleteAreaOfUseCategoryAdminFailPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.code, payload.error);
  }
}

export class EditAreaOfUseCategoryAdmin extends StateUtils.EntityLoadAction {
  readonly type = AreaOfUseAdminActionTypes.EditAreaOfUseCategoryAdmin;

  constructor(public payload: EditAreaOfUseCategoryAdminPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.code);
  }
}

export class EditAreaOfUseCategoryAdminSuccess extends StateUtils.EntitySuccessAction {
  readonly type = AreaOfUseAdminActionTypes.EditAreaOfUseCategoryAdminSuccess;

  constructor(public payload: EditAreaOfUseCategoryAdminSuccessPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.areaOfUse.code);
  }
}

export class EditAreaOfUseCategoryAdminFail extends PyStateUtils.EntityFailAction {
  readonly type = AreaOfUseAdminActionTypes.EditAreaOfUseCategoryAdminFail;

  constructor(public payload: EditAreaOfUseCategoryAdminFailPayload) {
    super(AREA_OF_USE_CATEGORY_ADMIN, payload.code, payload.error);
  }
}

export class PublishAreasOfUseAdmin extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.PublishAreasOfUseAdmin;

  constructor(public payload: string) {
    super(AREAS_OF_USE_PUBLISH_ADMIN);
  }
}

export class PublishAreasOfUseAdminSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.PublishAreasOfUseAdminSuccess;

  constructor() {
    super(AREAS_OF_USE_PUBLISH_ADMIN);
  }
}

export class PublishAreasOfUseAdminFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.PublishAreasOfUseAdminFail;

  constructor(public payload?: HttpErrorModel) {
    super(AREAS_OF_USE_PUBLISH_ADMIN, payload);
  }
}

export class ReplaceAreaOfUseAdminProduct extends StateUtils.LoaderLoadAction {
  readonly type = AreaOfUseAdminActionTypes.ReplaceAreaOfUseAdminProduct;

  constructor(public code: string, public userId: string, public oldProductCode: string, public newProductCode: string) {
    super(AREA_OF_USE_PRODUCTS_REPLACE);
  }
}

export class ReplaceAreaOfUseAdminProductFail extends PyStateUtils.LoaderFailAction {
  readonly type = AreaOfUseAdminActionTypes.ReplaceAreaOfUseAdminProductFail;

  constructor(public payload?: HttpErrorModel) {
    super(AREA_OF_USE_PRODUCTS_REPLACE);
  }
}

export class ReplaceAreaOfUseAdminProductSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = AreaOfUseAdminActionTypes.ReplaceAreaOfUseAdminProductSuccess;

  constructor(public code: string, public oldProductCode, public newProductCode: string) {
    super(AREA_OF_USE_PRODUCTS_REPLACE);
  }
}

export type AreaOfUseAdminActions =
  | LoadAreaOfUseListAdmin
  | LoadAreaOfUseListAdminSuccess
  | LoadAreaOfUseListAdminFail
  | LoadAreasOfUseForProduct
  | LoadAreasOfUseForProductSuccess
  | LoadAreasOfUseForProductFail
  | LoadAreasOfUseForProductReset
  | CreateAreaOfUseCategoryAdmin
  | CreateAreaOfUseCategoryAdminSuccess
  | CreateAreaOfUseCategoryAdminFail
  | DeleteAreaOfUseCategoryAdmin
  | DeleteAreaOfUseCategoryAdminSuccess
  | DeleteAreaOfUseCategoryAdminFail
  | EditAreaOfUseCategoryAdmin
  | EditAreaOfUseCategoryAdminSuccess
  | EditAreaOfUseCategoryAdminFail
  | PublishAreasOfUseAdmin
  | PublishAreasOfUseAdminSuccess
  | PublishAreasOfUseAdminFail
  | ReplaceAreaOfUseAdminProduct
  | ReplaceAreaOfUseAdminProductFail
  | ReplaceAreaOfUseAdminProductSuccess;
